<template>
  <table class="ui-table mb-16">

    <tr>

      <th>
        <div class="star-pad">
          <UiStar></UiStar>
        </div>
      </th>

      <th>
        <div>{{$t('AllInvoices.applicant')}}</div>
      </th>
      <th>
        <div>{{$t('AllInvoices.status')}}</div>
      </th>
      <th>
        <div>{{$t('AllInvoices.pay_date')}}</div>
      </th>
      <th>
        <div>{{$t('AllInvoices.amount')}}</div>
      </th>
      <th>
        <div>{{$t('AllInvoices.level')}}</div>
      </th>
      <th>
        <div>{{$t('AllInvoices.type')}}</div>
      </th>
      <th>
        <div>{{$t('AllInvoices.mode')}}</div>
      </th>
      <th>
        <div>{{$t('AllInvoices.invoice')}}</div>
      </th>
    </tr>

    <tr
        v-for="item in items"
        :key="item.id"
        @click="$emit('select', item)"
        class="hoverable" :class="{hover: item.id === currentItemId}">

      <td>
        <div class="table-cell star-pad">
          <UiStar :user="item"></UiStar>
        </div>
      </td>

      <td>
        <div class="table-cell nowrap">
          <UiAvatar class="user-avatar" :src="getAvatarUrl(item?.user?.photo?.key)"></UiAvatar>
          <span>
            {{ item.firstName }}&nbsp;{{ item.middleName }}&nbsp;{{ item.lastName }}
            <div class="mini-date">{{ $dayjs(item.createdAt).format('DD/MM/YYYY') }}</div>
          </span>
        </div>
      </td>
      <td>
        <UiStatus :student="item"></UiStatus>
      </td>
      <td>
        <div>{{ $dayjs(item.root.createdAt).format('DD/MM/YYYY') }}</div>
      </td>
      <td>
        <div>{{ item.root.levelPayment.requiredAmount }}€</div>
      </td>
      <td>
        <div class="uppercase">{{ item.root.levelPayment.languageLevel }}</div>
      </td>
      <td>
        <div>{{item.root.paymentBy}}</div>
      </td>
      <td>
        <div>{{item.root.mode}}</div>
      </td>
      <td>
        <div>in progres...</div>
      </td>
    </tr>
  </table>
</template>

<script>
import config from "@/config";
import UiAvatar from "@/components/ui/UiAvatar";
import UiStar from "@/components/ui/UiStar";
import UiStatus from "@/components/ui/UiStatus";

export default {
  name: "AllInvoices",
  components: {UiStatus, UiStar, UiAvatar},
  props: {
    items: {
      type: Array,
      required: true,
    },
    currentItemId: {}
  },
  emits: ['select'],
  methods: {
    getAvatarUrl(key) {
      if (key) return `${config.backendUrl}/${key}?token=${localStorage['feathers-jwt']}`;
      else return require('@/assets/images/no-avatar.jpg')
    },
    downloadCV(student) {
      const url = `${config.backendUrl}/${student.cv.key}?token=${localStorage['feathers-jwt']}`
      this.$log(url);
      window.open(url);
    },
  }
}
</script>

<style scoped>

</style>